import { msg } from "@lit/localize";
import { type TemplateResult, html } from "lit";
import "@whilecat/core/shoe.ts";
import { stringToListItem } from "../utils/string.ts";

export enum AlertType {
    INFO = "primary",
    SUCCESS = "success",
    WARNING = "warning",
    ERROR = "danger",
}

export function renderInfoAlert(output?: string | TemplateResult, header = msg("Output")) {
    return renderAlert(AlertType.INFO, header, "", output);
}

export function renderSuccessAlert(output?: string | TemplateResult, header = msg("Output")) {
    return renderAlert(AlertType.SUCCESS, header, "", output);
}

export function renderWarningAlert(output?: string | TemplateResult, header = msg("Warning")) {
    return renderAlert(AlertType.WARNING, header, "", output);
}

export function renderErrorAlert(
    errorText?: string | TemplateResult,
    header = msg("Incorrect Answer"),
    subHeader = msg("Please try again"),
) {
    return renderAlert(AlertType.ERROR, header, subHeader, errorText);
}

function renderAlert(type: AlertType, header: string, subHeader?: string, text: string | TemplateResult = "") {
    const out =
        typeof text === "string"
            ? html`
          <ul style="list-style: none; padding-left: 0;">
            ${stringToListItem(text ?? "")}
          </ul>
        `
            : text;

    return renderRawAlert(type, header, out, subHeader);
}

export function renderRawAlert(type: AlertType, header: string, template: TemplateResult, subHeader?: string) {
    return renderRawOutput(
        type,
        html`
          <div class="header" style="display: flex; align-items: center; gap: 6px">
            <sl-icon style="font-size: 16px" slot="icon" name="${getAlertIcon(type)}"></sl-icon>
            <strong>${header}</strong>
          </div>
          <p>${subHeader}</p>
          ${template}
        `,
    );
}

export function renderRawOutput(
    type: AlertType,
    template: TemplateResult,
    alertClass = "result-label",
    style: string = "",
) {
    return html`
      <sl-alert class="${alertClass}" style="${style}" variant="${type}" open>
        ${template}
      </sl-alert>
    `;
}

function getAlertIcon(type: AlertType): string {
    switch (type) {
        case AlertType.INFO:
            return "info-circle";
        case AlertType.SUCCESS:
            return "check-circle";
        case AlertType.WARNING:
            return "exclamation-octagon";
        case AlertType.ERROR:
            return "exclamation-circle";
    }
}
